export default __webpack_public_path__ + "static/media/deliland-sugar-icon.9657d860.png";